import { Pipe, PipeTransform, inject } from '@angular/core';
import { DurationUnit } from '@lx/shared/data-access/types';
import { DurationUnitsService } from '@lx/shared/utils/services';

@Pipe({
  name: 'lxDurationUnitsLabel',
  standalone: true,
})
export class DurationUnitsLabelPipe implements PipeTransform {
  private readonly durationUnitsService = inject(DurationUnitsService);

  transform(quantity: number | string, durationUnit: DurationUnit = 'WEEKS') {
    return this.durationUnitsService.getDurationText(quantity, durationUnit);
  }
}
